module.exports = __webpack_public_path__ + "img/getcertificate.b8f8d4ec.png";